import { Component, HostListener, inject } from '@angular/core';
import { GlobalConstants } from '../global-constants';
import { QueryService } from '../services/query.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MisdatosService } from '../services/misdatos.service';
import { ProductosService } from '../services/productos.service';
import { FuncionesService } from '../services/funciones';
import { ConexionService } from '../services/conexion.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  misdatos: any = {};
  private productosSub!: Subscription;
  productos: any[] = [];
  global: any = GlobalConstants;
  isScrolled: boolean = false;
  listaNotificaciones: any[] = [];
  private wsSubscription!: Subscription;
  private conexionService = inject(ConexionService);
  // Mapeamos el signal o el observable para la vista
  estaOnline = this.conexionService.estaConectado;

  constructor(
    private query: QueryService,
    private misdatosService: MisdatosService,
    public productosService: ProductosService,
    public funciones: FuncionesService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getMisDatos();
    // Escuchamos el observable de los productos
    this.productosSub = this.productosService.productos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((productos): productos is any => productos !== null),
      )
      .subscribe((productos: any) => {
        // Ya tenemos datos
        this.productos = productos;
      });
    
    // Si prefieres suscribirte al Observable clásico para lanzar alertas:
    this.conexionService.conectado$.subscribe(conectado => {
      if (!conectado) {
        this.toastr.error("Te has quedado sin internet. Revisa tu cobertura.");
      } else {
        this.toastr.success("¡Conexión restablecida!");
      }
    });
  }

  ngOnDestroy() {
    // Buenas prácticas: nos desuscribimos al destruir el componente para evitar fugas de memoria
    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
    }
  }

  getMisDatos() {
    this.query.query('misdatos', 'GET', null).subscribe((resultado: any) => {
      this.misdatos = resultado;
      // Guardamos los datos en el servicio para reutilizarlo en otros componentes
      this.misdatosService.setMisDatos(this.misdatos);
    });
  }

  getProductosCheck(check: string = '') {
    return this.productos.filter((item) => item.pr_check === check);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.isScrolled = scrollY > 50;
  }

  irInicio() {
    window.location.href = GlobalConstants.urlServer;
  }
}
